import { Spinner, SpinnerSize } from "office-ui-fabric-react";
import React, { Component } from "react";

interface LoadingPageProps {
    style?: React.CSSProperties;
}

interface LoadingPageState {

}

export default class LoadingPage extends Component<LoadingPageProps, LoadingPageState>
{
    constructor(props: LoadingPageProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <div className = "flex-item--flex-1 flex-column flex--align-items-center flex--justify-content-center" >
                <Spinner label="Loading..." labelPosition="right" size={SpinnerSize.large} className="flex-item"/>
            </div>
        );
    }
}